import axios from './index';

class DashboardReportApi {
  static List = (data) => {
    let query = '?';
    if (data.filterStartDate) {
      query += `start_date=${data.filterStartDate}&`;
    }
    if (data.filterEndDate) {
      query += `end_date=${data.filterEndDate}&`;
    }
    this.Notifications();
    return axios.get(`${base}${query}`);
  };

  static Notifications = async () => {
    let query = '?';
    let notificationsResponse = await axios.get(`${url2}${query}`);
    notificationsResponse = notificationsResponse.data;
    if (notificationsResponse?.status_code === 200) {
      sessionStorage.setItem(
        'notificationssummary',
        JSON.stringify(notificationsResponse.data)
      );
    }
  };
  static GetReports = (data) => {
    let query = '?';
    Object.keys(data).forEach((key) => {
      if (data[key]) {
        query += `${key}=${data[key]}&`;
      }
    });
    return axios.get(`${reportBase}${query}`);
  };
}

let base = '/dashboard/reports/summary';
let url2 = '/dashboard/notifications/summary';
let reportBase = '/dashboard/admin/get-reports';

export default DashboardReportApi;
